import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { getUsersGroupList } from '../../services/ClubeApi'

function SelectUserGroupFilter({ filterAction }) {
  const [groupList, setGroupList] = useState([])

  useEffect(() => {
    getUsersGroupList().then(r => {
      setGroupList(r)
    })
  }, [])

  return (
    <div className="col-lg-3 col-sm-12 input-group">
      <select className="custom-select" onChange={e => filterAction(e.target.value)}>
        <option defaultValue value="0">
          Tudo
        </option>
        {groupList.map(item => (
          <option value={item.id} key={item.id}>
            {item.name}
          </option>
        ))}
      </select>
    </div>
  )
}

SelectUserGroupFilter.propTypes = {
  filterAction: PropTypes.func.isRequired
}

export default SelectUserGroupFilter
